import { useStoredState } from "../../hooks";
import type { Density } from "./DataTableTypes";

/** localStorage key of a table preference; tables without an id keep theirs in memory only. */
function storageKey(tableId: string | undefined, preference: "density" | "pageSize"): string | undefined {
  return tableId ? `nabble.dt.${tableId}.${preference}` : undefined;
}

export interface TablePreferenceDefaults {
  density: Density;
  pageSize: number;
}

/** Density and page size, remembered per table id. */
export interface TablePreferences {
  density: Density;
  toggleDensity: () => void;
  pageSize: number;
  setPageSize: (size: number) => void;
}

export function useTablePreferences(tableId: string | undefined, defaults: TablePreferenceDefaults): TablePreferences {
  const [density, setDensity] = useStoredState<Density>(storageKey(tableId, "density"), defaults.density);
  const [pageSize, setPageSize] = useStoredState<number>(storageKey(tableId, "pageSize"), defaults.pageSize);
  return {
    density,
    toggleDensity: () => setDensity(density === "compact" ? "comfortable" : "compact"),
    pageSize,
    setPageSize,
  };
}
